<template>
    <v-app>
        <vue-headful title="ePlato Відпрацювання"/>

        <toolbar
                :is-lang-switcher="false"
                color="deep-orange darken-4"
                @toggleDrawer="drawerApp = !drawerApp"
        />

        <navigation v-if="$route.name !== 'reworkSuperAdminPreselect'" @toggleDrawer="drawerApp = $event" :drawer="drawerApp"/>

        <v-main>
            <router-view :key="$route.fullPath"/>
        </v-main>
        <snack-displayer/>
    </v-app>
</template>

<script>
    import Toolbar from "../../components/reworks/common/ReworksToolbar";
    import ReworksNavigationDrawer from "../../components/reworks/common/ReworksNavigationDrawer";
    import SnackDisplayer from "../../components/common/SnackDisplayer";

    export default {
        components: {
            Toolbar,
            navigation: ReworksNavigationDrawer,
            snackDisplayer: SnackDisplayer,
        },
        data: () => ({
            drawerApp: true,
            drawerTeacherNav: false,
        }),
    }
</script>
